import { render, staticRenderFns } from "./newindex.vue?vue&type=template&id=3bf23e03"
import script from "./newindex.vue?vue&type=script&lang=js"
export * from "./newindex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports